module.exports = __webpack_public_path__ + "static/media/details-chat-button.b2d3b0fa.svg";